import { storyblokEditable } from "gatsby-source-storyblok"

import SliderSection from "../../../V2/Layouts/SliderSection"

import ProductCard from "@components/V2/Cards/Product"
import { Color } from "@constants/V2/color"
import { useShopItems } from "@hooks/V2/storyblok/useShopItems"
import { storyblokLinkToYocoLink } from "@utils/storyblok"
import { consolidatedItemToProductCard } from "@utils/V2/productCard"
import React from "react"

const ALL_PRODUCTS = "ALL"
const ONLINE_PRODUCT = "onlineProduct"

const StoryblokProductShowCase = ({
  blok,
}: Storyblok.BlokProps<Storyblok.ProductShowCase>) => {
  const { catalogueItems } = useShopItems(blok.useInternalItems)

  const display = blok.display || ALL_PRODUCTS

  const displayedItems = catalogueItems.filter(
    (item) =>
      (blok.includeOnlineProducts || item.type !== ONLINE_PRODUCT) &&
      (display === ALL_PRODUCTS || item.filterTags.includes(display))
  )

  if (displayedItems.length === 0) return null

  return (
    <SliderSection
      id={blok.id}
      sectionId={blok._uid}
      headingSize={blok.headingSize}
      headingText={blok.headingText}
      subheadingText={blok.subheadingText}
      overrideHeadingColor={blok.overrideHeadingColor}
      cardWidth={blok.cardWidth}
      primaryBackgroundColor={blok.primaryBackgroundColor}
      secondaryBackgroundColor={blok.secondaryBackgroundColor}
      ctaType={blok.ctaType}
      ctaText={blok.ctaText}
      ctaColor={blok.ctaColor}
      ctaLink={storyblokLinkToYocoLink(blok.ctaLink)}
      trackingEvent={blok.trackingEvent}
      trackingEventKey={blok.trackingEventKey}
      trackingEventValue={blok.trackingEventValue}
      autoplay={blok.autoplay}
      // @ts-ignore to have more strict typing compared to Storybloks generic object typing
      {...storyblokEditable(blok)}
    >
      {displayedItems.map((item) => {
        const product = consolidatedItemToProductCard(item)

        return (
          <ProductCard
            key={item.storyblokUuid}
            productName={product.productName}
            imageUrl={product.imageUrl}
            imageAlt={product.imageAlt}
            priceValue={product.priceValue}
            priceLabelOverride={product.priceLabelOverride}
            shortDescription={product.shortDescription}
            ctaText={product.ctaText}
            ctaLink={product.ctaLink}
            learnMoreButtonUrl={
              blok.showLearnMoreCTA ? product.learnMoreButtonUrl : undefined
            }
            purchasableItem={product.purchasableItem}
            reviewSkus={product.reviewSkus}
            badge={product.badge}
            wasPrice={product.wasPrice}
            backgroundColor={blok.cardBackgroundColor || Color.White}
            isSliderChild={true}
          />
        )
      })}
    </SliderSection>
  )
}

export default StoryblokProductShowCase
